module.exports = __webpack_public_path__ + "img/service_bg_full.d0d88de9.png";